import { useCallback, useMemo } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { getAuth0Config } from '@/config/auth0';
import { safeReturnTo } from '@/lib/auth/authFlow';

interface Auth0AppProviderProps {
  children: React.ReactNode;
}

/**
 * Auth0 SDK boundary. The SDK exclusively owns processing code/state on the
 * configured /auth/callback URL. Application login decisions are made by
 * AuthenticationController.
 */
export function Auth0AppProvider({ children }: Auth0AppProviderProps) {
  const config = useMemo(() => getAuth0Config(), []);

  const handleRedirectCallback = useCallback((appState?: { returnTo?: string }) => {
    window.location.replace(safeReturnTo(appState?.returnTo));
  }, []);

  return (
    <Auth0Provider {...config} onRedirectCallback={handleRedirectCallback}>
      {children}
    </Auth0Provider>
  );
}
